import styled from "styled-components";

const HomeMineWrap = styled.div`
  padding: 72px 0 32px;
  img {
    width: 100%;
    margin-bottom: 72px;
    margin-top: 21px;
    @media(max-width: 768px) {
      margin-bottom: 42px;
      margin-top: 12px;
    }
  }
`

export default HomeMineWrap